import { FAQItem } from '@claim/types';

export const faqContent: FAQItem[] = [
  {
    question: 'What are the allocations per Doodles collectible?',
    answer:
      "Doodles Community allocations are based on the Doodles ecosystem assets you hold. Each asset type has its own allocation of $DOOD. Additionally, Space Doodles will receive a bonus amount based on the number of Space Miles they've accumulated. The following assets are eligible to receive $DOOD as part of the Doodles Community allocation:",
    hasList: true,
    listItems: [
      'OG Doodles',
      'Space Doodles',
      'Dooplicators',
      'Genesis Boxes',
      'Iconic Wearables',
      'Grail Wearables',
      'Exclusive Wearables',
      'Essential Wearables',
      'Posters',
      'Beta Passes',
      'Certified Virals',
      'Doodles Passes',
      'Space Miles',
    ],
    isOrderedList: false,
  },
  {
    question: 'What is community pre-registration?',
    answer:
      'Community pre-registration is a way for Doodles holders to receive their $DOOD tokens without needing to manually claim them. By registering your Solana wallet ahead of TGE (Token Generation Event), you’ll automatically receive your tokens in your Solana wallet at TGE, no claim or extra steps required.',
  },
  {
    question: 'Is my pre-registration allocation final? What if I move assets?',
    answer: `Your pre-registration allocation is a preview, not final. The final amount depends on eligible collectibles in your wallet when the airdrop takes place. If you move or sell these collectibles before this snapshot, they won't count towards your airdrop. Check dood.doodles.app for updates.`,
  },
  {
    question: 'When is the token airdrop?',
    answer: 'Token airdrop will take place at the time of TGE.',
  },
  {
    question: 'What if I miss community pre-registration?',
    answer:
      "No worries! You'll still be able to claim your tokens manually on dood.doodles.app after the airdrop goes live.",
  },
  {
    question: 'When does the claim begin?',
    answer: 'Token claim will begin at the time of TGE.',
  },
  {
    question: 'How long is the claim window?',
    answer: 'The claim window will be open for 77 days from the date of TGE.',
  },
  {
    question: 'Are delegate wallets supported?',
    answer:
      'Yes! If you delegate your ledger (Wallet B) to your hot wallet (Wallet A) via Delegate.xyz, simply connect your hot wallet to claim your $DOOD. Our system automatically reads your hot wallet, detects any incoming delegations (like Wallet B), and calculates your total claimable amount.\n\nDelegate wallets need to be registered via delegate.xyz.',
  },
  {
    question: 'Do I need to perform extra steps for my delegated wallet?',
    answer:
      "No. Once you connect your hot wallet, everything happens automatically. There's no need to manually link or verify your ledger—our system handles it all in the background.",
  },
  {
    question: 'What chain is the token on?',
    answer:
      '$DOOD will launch with a total supply of 10,000,000,000 tokens​, initially on the Solana blockchain for fast and low-cost transactions. We will bridge $DOOD to Base L2 shortly thereafter, establishing it as a cross-chain asset. This allows the widest reach (Solana for speed and breadth, Ethereum/Base for integration with existing NFT markets and the first iteration of DreamNet).',
  },
  {
    question: 'What wallet should I use to claim?',
    answer:
      "You can use any wallet you're comfortable with, but you may need to connect two wallets during the claim process:",
    hasList: true,
    listItems: [
      'An Ethereum wallet that holds your eligible Doodles assets',
      'A Solana wallet where your $DOOD tokens will be sent',
    ],
    isOrderedList: true,
  },
  {
    question:
      'Which partner communities will receive the New Blood allocation at TGE?',
    answer:
      '13% of the total supply of $DOOD will be allocated to communities that align with our mission and values. Additional partner communities have been identified and will receive token allocations in future phases as part of our $DOOD expansion efforts.',
    hasList: true,
    listItems: [
      'BonkBot - Top 50 active traders by volume',
      'Bonk - Top 2.5k wallets from Bonk rewards program',
      'drip.haus - DRiP creators who were active between Jan 1 – Mar 5, select holders of Doodles Collectibles on DRiP',
      'Solana Mobile - Solana Mobile Chapter 2 Preorders',
      'Vector - Top 2,500 Wallets by Broadcast Volume',
      'Helius - Top 5,000 helius stakers',
      'ElizaOS - ElizaOS Contributors',
      'The Pond - collectors of NFT collection (snapshot taken May 6th)',
      'Claims for select BSC communities (TST, Mubarak, Babydoge, Broccoli714, Koma Inu) will be managed directly by their respective projects',
    ],
  },
  {
    question:
      'How can I check if a collectible has any unclaimed $DOOD allocation?',
    answer:
      'This information is only visible to the current holder of the NFT. If you own the collectible, just connect your wallet to the claim app and it will automatically show whether any $DOOD is available to claim.',
  },
  {
    question: 'What is the $DOOD contract address?',
    answer: 'DvjbEsdca43oQcw2h3HW1CT7N3x5vRcr3QrvTUHnXvgV',
  }
];
